import { QuestionMethods } from '../questionMethods.types';
import {
	MultipleSelectGivenAnswer,
	RenderedMultipleSelectQuestion,
} from './multipleSelectMethods.types';

export const getMultipleSelectAnswerListItems: QuestionMethods<
	RenderedMultipleSelectQuestion,
	MultipleSelectGivenAnswer
>['getAnswerListItems'] = ({ question, givenAnswers, answerListData }) => {
	const answerData = answerListData.multiple?.[question.id];
	if (answerData == null) return [];
	const givenAnswer = givenAnswers.multiple.get(question.id);
	if (givenAnswer == null) return [];

	const items = question.answers
		.filter((answer) => givenAnswer.has(answer.id))
		.map((answer) => {
			return {
				title: answer.title,
				explanation: answer.explanation,
			};
		});

	return items;
};
